import { createContext, useContext } from "react";
import { Demo } from "../templates/types";

export const DemoContext = createContext<{ [key: string]: any } | null>(null);

export function useDemos() {
  return useContext(DemoContext) as Array<Demo>;
}
